// ===== Slash Command Token (SSOT) =====
// 슬래시 명령 토큰 파싱의 단일 정의. 프런트(classic script 전역)와 서버(lib/skill-router)가
// 같은 컴파일 산출물을 소비한다 — 정의를 복제하면 한글 명령이 한쪽에서만 살아나는 기존 결함이
// 그대로 재현된다.
//
// `\w`(=[A-Za-z0-9_])는 한글/일본어/키릴을 배제해 "/계약서 x".match(/^(\/\w+)/) 가 null 이었다.
// `\p{L}\p{N}` + `u` 플래그는 ASCII 를 그대로 포함하는 상위집합이라 기존 ASCII 동작은 보존된다.
//
// 이 파일은 tsconfig.frontend(module:"None")로만 컴파일된다. Node 소비자(lib/skill-router)는
// dist 산출물을 런타임 require 로 읽고, 브라우저에는 `module` 이 없어 아래 꼬리가 건너뛰어진다.

type SlashCommandParts = { command: string; args: string };

declare const module: { exports: Record<string, unknown> } | undefined;

const SLASH_COMMAND_PATTERN = /^(\/[\p{L}\p{N}_]+)\s*([\s\S]*)$/u;

// 매치되면 { command: "/할일", args: "우유사기" }, 아니면 null.
// args 는 [\s\S]* 로 개행을 포함한다 — 여러 줄 인자를 첫 줄에서 잘라내지 않는다.
function parseSlashCommand(text: string): SlashCommandParts | null {
  const match = SLASH_COMMAND_PATTERN.exec(text);
  if (!match) return null;
  return { command: match[1], args: match[2] };
}

if (typeof module === "object" && module) {
  module.exports = { SLASH_COMMAND_PATTERN, parseSlashCommand };
}
